<template>
  <div class="prepare-container">
    <div class="test-bg" v-if="!showList.length" :class="{'test-bg-Tablet':isTablet}">
      <img src="../images/no_data.png" alt="">
      <span> 暂无数据～</span>
    </div>
    <el-table
    :data="showList"
    style="width: 100%"
     v-else
    >
    <el-table-column
      prop="evaluate_name"
      label="名称"
    >
      <template slot-scope="scope">
        <div class="practice">
          <span class="practice_tips one"
           v-if="scope.row.type==3 && scope.row.source_type==1">同步练习</span>
          <span class="practice_tips two"
           v-else-if="scope.row.type==4 && scope.row.source_type==1 ">个性化练习</span>
          <span class="practice_tips three"
           v-else-if="scope.row.type==3 && scope.row.source_type==2">高频错题</span>
          <span class="practice_tips four"
           v-else-if="scope.row.type==4 && scope.row.source_type==3">薄弱知识点</span>
          <div style="color: #1989FA;">
            {{scope.row.evaluate_name}}
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="right_num"
      label="练习状态"
      width="150"
      align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.evaluate_status==1">
           <span class="finished">已完成</span>
          </div>
          <div v-else>
            <span class="unfinished">未完成</span>
          </div>
        </template>
    </el-table-column>
     <el-table-column
      prop="created"
      label="发布时间"
      width="250"
      align="center"
      sortable>
    </el-table-column>
    <el-table-column
      label="操作"
      align="center"
      width="120"
      >
       <template slot-scope="scope">
          <a @click="handlerClick(scope.row)" class="go-record">查看</a>
        </template>
    </el-table-column>
    </el-table>
       <!-- 分页控件 -->
    <div class="prepare-pagination" v-if="showList.length">
      <el-pagination
       background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"

      :page-sizes="[10,20,50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import api from '@/pages/uc-web/api/api';
import { openTab } from '@/utils';
import { userAgentType, isApp } from '@/utils/index';

// import { getSign } from '@/pages/uc-web/utils/verify';

export default {
  name: 'PracticeRecord',
  props: {
    activeId: {
      default: '0',
      type: String,
    },
    prevList: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      default: 10,
      type: Number,
    },
    total: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      currentPage: 1,
      isTablet: false,
    };
  },
  mounted() {
    this.isTablet = userAgentType().isTablet;
  },
  methods: {
    async handlerClick(row) {
      console.log(row.subject_id,888888888888);
      localStorage.setItem('evaluate_name', row.evaluate_name);
      const params = {
        school_id: localStorage.getItem('school_id'),
        account_id: localStorage.getItem('account_id'),
        evaluate_id: row.evaluate_id,
        // evaluate_id: '81037',
        type: row.type,
      };
      const res = await api.getStuTaskTokenInfo(params);

      const jupiterToken = res.data;
      const isProduction = !window.location.host.includes('test') && !window.location.port.includes('8080');
      // 区分线上和测试环境
      // const host = isProduction
      // ? 'http://jzjx.classba.cn'
      // : 'http://jzjx-test.classba.cn';
      let host;
      if (isApp()) {
        host = `https://${window.location.host}`;
      } else {
        host = `http://${window.location.host}`;
      }

      const realname=localStorage.getItem('real_name')||'';
      console.log('看看host',host);
      
      //mt作业
      if (row.type == 3) {
        //文科同步练习
        if (row.subject_id==1||row.subject_id==3) {
          openTab(encodeURI(`${host}/artsSelf/welcome?jupiterToken=${jupiterToken}&realname=${realname}`));
          return
        }
        //理科同步练习
        openTab(encodeURI(`${host}/mt-web/welcome?jupiterToken=${jupiterToken}&realname=${realname}`));
      } else {
        // window.location.href = encodeURI(`${host}/amt-web/welcome?jupiterToken=${jupiterToken}&realname=${realname}`);
        openTab(encodeURI(`${host}/amt-web/welcome?jupiterToken=${jupiterToken}&realname=${realname}`));
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.pageSize = val;
      this.$emit('changePageSize', val);
      // localStorage.setItem('pageSize', val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.$emit('changeCurrent', val);
      localStorage.setItem('currentPage', val);
    },
  },
  computed: {
    showList() {
      if (this.activeId === '0') {
        return this.prevList;
      }
      return this.prevList.filter((item) => item.subject_id.toString() === this.activeId);
    },
  },
};
</script>

<style lang="scss" scoped>
.prepare-container{
  font-family: PingFangSC-Medium, PingFang SC;
  // position: relative;
  .test-bg-Tablet{
    width: 100% !important;
  }
  .test-bg{
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      span{
        position: absolute;
        left: 50%;
        transform: translate(-50%,70px);
        font-size: 14px;
        font-weight: 400;
        color: rgba(17, 31, 44, 0.6);
      }
  }
  .finished{
    font-size: 14px;
    color: #67C23A;
     position: relative;
    &::before{
        content: '';
        width: 6px;
        height: 6px;
        background: #67C23A;
        border-radius:50% ;
        left: -8px;
        top: 8px;
        position: absolute;
    }
  }
   .unfinished{
    font-size: 14px;
    color: #F6676A;
     position: relative;
    &::before{
        content: '';
        width: 6px;
        height: 6px;
        background: #F6676A;
        border-radius:50% ;
        left: -8px;
        top: 8px;
        position: absolute;
    }
  }
  .go-record{
    font-weight: 500;
    color: #1989FA;
    cursor: pointer;
  }
  .prepare-pagination{
    height: 103px;
    display: flex;
    align-items: center;
  }
}

  /deep/.el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    // position: absolute;
    width: calc(100% - 64px);
    // bottom: 30px;
    // left: 32px;
    .btn-prev {
      margin-left: auto !important;
    }
  }
  .practice{
    display: flex;
    align-items: center;
    &_tips{
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-right: 9px;
      padding: 1px 2px;
      border-radius: 4px;
      white-space:nowrap
    }
    .one{
      border: 1px solid #0DD4C8;
      color: #0DD4C8;
    }
    .two{
      border: 1px solid #27ACFF;
      color: #27ACFF;
    }
    .three{
      border: 1px solid #F56C6C;
      color: #F56C6C;
    }
    .four{
      border: 1px solid #FF8D27;
      color: #FF8D27;
    }
  }
</style>
